$('document').ready(function () {

    if (document.getElementById('ChooseRegType')) {
        $('#ChooseRegType').formValidation({
            fields: {
                'email': {
                    verbose: false,
                    validators: {
                        remote: {
                            type: 'POST',
                            headers: {
                                'X-CSRF-TOKEN': window.Laravel.csrfToken
                            },
                            url: "/Register/checkemail",
                            name: 'email',
                            data: {email: $('.email').val()},
                            dataType: 'json',
                            validKey: 'is_valid',
                            message: "This email already exists in the database. <span class='reset-field'><a data-toggle='modal' href='#window-reset'>Reset password?</a></span>"
                        }
                    }
                }
            }
        });


        $('.cloud').click(function (e) {
            e.preventDefault();
            $(".Register-Chose .error").html("").fadeOut();
            $('#ChooseRegType').data('formValidation').validate();
            isValid = $('#ChooseRegType').data('formValidation').isValid();

            if (isValid) {
                var data = {
                    href: $(this).attr('href'),
                    email: $("#ChooseRegType input[name='email']").val()
                }

                $.when(postRequest(data, "/pre-register"))
                    .done(function (answer) {
                            if (answer.url) {
                                window.location.href = answer.url;
                            }
                            if (answer.error) {
                                $(".Register-Chose .error").html(answer.error).fadeIn();
                            }
                        }
                    );
            }

        });

        function postRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

    }
});